import React, { useState } from 'react'
import classes from "./style.module.scss";

const EnquireMessage = ({enquiryID, enquiryMessgae,comments, admin}) => {

    return (
        <>
            <div className={`${classes.enquiryCardWrapper} mb-4`}>
                <div className={`${classes.detailsWrapper}`}>
                    <div className='flex items-center mb-5'>
                        <div className={`${classes.informationHeader} ${classes.highlighted} flex items-center !mb-0 fs-20 `}>
                            Enquiry Id :#{enquiryID}
                        </div>
                    </div>
                    <div className={`${classes.infoWrapper} !block`}>
                        <div className={`${classes.fullWidthInfoCategory}`}>
                            <div className={`${classes.infoLabel}`}>Enquiry Message</div>
                            <div className={`${classes.infoValue}`}>{enquiryMessgae}</div>
                        </div>
                        {comments && <div className={`${classes.fullWidthInfoCategory}`}>
                            <div className={`${classes.infoLabel}`}>Reply comment</div>
                            <div className={`${classes.infoValue}`}>{comments}</div>
                        </div>}
                        {admin && <div className={`${classes.inforCategory}`}>
                            <div className={`${classes.infoLabel}`}>Admin Comment</div>
                            <div className={`${classes.infoValue}`}>{admin}</div>
                        </div>}
                    </div>
                </div>
            </div>
        </>
    )
}

export default EnquireMessage